
/**
 * Module dependencies.
 */

import { UserJobTitle, UserProfessionalType } from 'src/types/user';
import {
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  formData: {
    company?: string | null,
    countryAlpha2: string,
    districtId: string,
    jobTitle?: UserJobTitle | null,
    location?: string | null,
    name: string,
    phoneNumber?: string | null,
    professionalType?: UserProfessionalType | null
  },
  token: string
};

/**
 * Export `updateUser`.
 */

export async function updateUser({ formData, token }: Query) {
  const endpoint = getApiEndpoint('getUser');

  try {
    const { data } = await request.put(endpoint, formData, {
      headers: authorizationHeader(token)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
